import * as React from 'react';

import { Text } from '../Text';

interface Props extends React.HTMLProps<HTMLDivElement> {
  h?: '500' | '700' | '800' | '900';
}
export const Heading: React.FC<React.PropsWithChildren<Props>> = ({ h = '700', ...props }) => <Text h={h} {...props} />;
